"use client";

import type { FormData } from "./page";
import { LovePageView } from "../[slug]/love-page-view";

export function PagePreview({ data }: { data: FormData }) {
	return (
		<div className="relative overflow-hidden rounded-[32px] border border-border bg-card shadow-2xl">
			<LovePageView
				title={data.title || "Seu título especial"}
				message={data.message}
				coupleName1={data.coupleName1}
				coupleName2={data.coupleName2}
				relationshipDate={data.relationshipDate}
				musicUrl={data.musicUrl}
				imageUrls={data.imagePreviewUrls}
				isPreview
			/>
		</div>
	);
}
